export default __webpack_public_path__ + "static/media/R2.1ba0a5b7.png";